/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Box, Button, Stepper, Step, StepLabel, Typography } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import Activities from "./Activities";
import MentorAfterSchool from "./MentorAfterSchool";
import MentorGroup from "./MentorGroup";
import Languages from "./Languages";
import theme from "../Styles/StudentBackgroundStyle";
import { useDispatch, useSelector } from "react-redux";
import { postQuestionsData } from "../../store/studentSlice";
import { setNestedStep } from "../../store/commonSlice";
import { isEmpty } from "../../utils/constants";
import useMediaQuery from "@mui/material/useMediaQuery";
import Style from "../Styles/CssModulesGlobal.module.scss";
import WarningPopUp from "../common/WarningPopUp";
import { updateMentor } from "../../store/mentorSlice";
import en from '../../nls/en.json';

const cssObj = {
    "& .MuiStepConnector-root": {
        left: "calc(-50% + 7px)",
        right: "calc(50% + 7px)",
    },
    "& .MuiStepLabel-labelContainer": {
        display: "none",
    },
    "& .MuiStepConnector-line": {
        borderTopWidth: "4px",
        display: "none",
    },
    "& .MuiStepIcon-root": {
        backgroundColor: "#999999",
        height: "4px",
        borderRadius: "4px"
    },
    "& .MuiSvgIcon-root circle": {
        display: "none",
    },
    "& .MuiStepIcon-text": {
        display: "none",
    },
    "& .MuiStepIcon-root.Mui-active": {
        backgroundColor: "#1468A2",
    },
    "& .Mui-completed .MuiStepIcon-root": {
        backgroundColor: "#1468A2",
    },
    mb: 5,
}

const getInnerSteps = () => ["Step 1", "Step 2", "Step 3", "Step 4"];

function getInnerStepContent(stepInner, data, getActivities, getAfterSchool, getGroup, getLang) {
    switch (stepInner) {
        case 0:
            return <MentorAfterSchool getAfterSchool={getAfterSchool} data={data} />;
        case 1:
            return <Activities getActivities={getActivities} />;
        case 2:
            return <MentorGroup getGroup={getGroup} data={data} />;
        case 3:
            return <Languages getLang={getLang} data={data} />;
    }
}

const MentorBackground = (data) => {

    const dispatch = useDispatch();
    const { loggedInUserId } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
    const { isNestedstepCompleted } = useSelector(({ common }) => common);
    const [activeStep, setactiveStep] = React.useState(0);
    const stepsInner = getInnerSteps();
    const handleNextInner = () => setactiveStep((prevActiveStep) => prevActiveStep + 1);

    // Nested forms data
    const [activities, setActivities] = useState({});
    const [afterSchool, setAfterSchool] = useState({});
    const [group, setGroup] = useState({});
    const [lang, setLang] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);

    // Nested callback function.
    const getActivities = (data) => setActivities(data);
    const getAfterSchool = (data) => setAfterSchool(data);
    const getGroup = (data) => setGroup(data);
    const getLang = (data) => setLang(data);

    const handleCloseDialog = () => setOpenDialog(false);

    const afterSchoolQuestionId = data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "LIKE_TO_DO_AFTER_SCHOOL")?.question_id;
    const groupQuestionId = data?.data?.MENTOR_BACKGROUND?.find(item => item?.sub_category_name === "MENTOR_WHOS_SIMILAR_BACKGROUND_TO_YOU")?.question_id;
    const langQuestionId = data?.data?.MENTOR_BACKGROUND?.find(item => item.sub_category_name === 'ENGLISH_IS_NOT_YOUR_FIRST_LANGUAGE')?.question_id;
    
    const nestedPostCall = () => {
        const handleDialogOpen = () => setOpenDialog(true);

        if (activeStep === 0 && !afterSchool.length) {
            handleDialogOpen();
            return;
        } else if (activeStep === 1 && !activities.length) {
            handleDialogOpen();
            return;
        } else if (activeStep === 3) {
            if (isEmpty(lang?.optionSelected)) {
                handleDialogOpen();
                return;
            } else if (lang?.optionSelected?.option_text === "Yes" && lang?.selectedLanguage === null) {
                handleDialogOpen();
                return;
            }

        } else if (activeStep === 2 && isEmpty(group)) {
            handleDialogOpen();
            return;
        }

        const payLoad = { "user_id": loggedInUserId, "responses": [] }
        if (!isEmpty(afterSchool)) {
            payLoad?.responses?.push({ "question_id": afterSchoolQuestionId, "selected_options": afterSchool })
        }
        if (!isEmpty(group)) {
            payLoad?.responses?.push({ "question_id": groupQuestionId, "selected_options": group })
        }
        if (activities && activeStep === 1) {
            dispatch(updateMentor(loggedInUserId, { "extracurricular_interests": activities }));
        }

        if (activeStep === 3) {
            payLoad?.responses?.push({
                "question_id": langQuestionId,
                "selected_options": [lang?.optionSelected],
                "master_data_id": isEmpty(lang?.selectedLanguage) ? [] : lang?.selectedLanguage?.map(e => e?.id)
            });
        }

        if (!isEmpty(payLoad?.responses)) {
            dispatch(postQuestionsData(payLoad));
        }

        handleNextInner();
        const afterNestedFinalStep = activeStep === stepsInner.length - 1 ? true : false
        if (afterNestedFinalStep) {
            dispatch(setNestedStep(isNestedstepCompleted + 1));
        }
    }

    useEffect(()=>{
        if(data?.myRef){
          data.myRef.current.scrollTop = 0;
        }
      },[activeStep]);

    const isMobile = useMediaQuery("(max-width:767px)", { noSsr: true });
    return (
        <ThemeProvider theme={theme}>
            {isMobile ? (
                <Typography variant="h1" className={Style.stepperTitleMobile}>Student Background</Typography>
            ) : (
                ""
            )}
            <Box className="inner-stepper">
                <Box variant="form">
                    <Stepper
                        alternativeLabel
                        activeStep={activeStep}
                        sx={cssObj}
                    >
                        {stepsInner.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {getInnerStepContent(activeStep, data, getActivities, getAfterSchool, getGroup, getLang)}
                    <WarningPopUp
                        openDialog={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        dialogMessage={'Please select at least one option'}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "32px",
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => {
                                nestedPostCall()
                            }}
                            sx={{ mr: 1 }}
                        >
                            {en.NEXT}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default MentorBackground;